"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paidSubscriptions = void 0;
var subscription_enum_1 = require("../enums/subscription-enum");
exports.paidSubscriptions = [subscription_enum_1.SubscriptionEnum.Premium, subscription_enum_1.SubscriptionEnum.PremiumPlus];
//# sourceMappingURL=paid-subscriptions.js.map